import { useMemo } from 'react';
import { LogEmptyState } from './LogEmptyState';

export function EnvViewer({ content, filter }: { content: string; filter: string }) {
  const pairs = useMemo(() => {
    return content
      .split('\n')
      .filter((l) => l.trim())
      .map((line) => {
        const eqIdx = line.indexOf('=');
        if (eqIdx === -1) return { key: line, value: '' };
        return { key: line.slice(0, eqIdx), value: line.slice(eqIdx + 1) };
      });
  }, [content]);

  const filtered = useMemo(() => {
    if (!filter) return pairs;
    const lower = filter.toLowerCase();
    return pairs.filter(
      (p) => p.key.toLowerCase().includes(lower) || p.value.toLowerCase().includes(lower),
    );
  }, [pairs, filter]);

  return (
    <div className="space-y-0.5">
      {filtered.map((pair) => (
        <div
          key={pair.key}
          className="flex items-start gap-3 rounded-md px-2.5 py-1.5 hover:bg-foreground/2 transition-colors"
        >
          <span className="font-mono text-2xs text-status-accent-purple shrink-0 font-medium">
            {pair.key}
          </span>
          <span className="text-muted-foreground">=</span>
          <span className="font-mono text-2xs text-foreground/80 break-all">
            {pair.value || <span className="text-muted-foreground italic">(empty)</span>}
          </span>
        </div>
      ))}
      {filtered.length === 0 && <LogEmptyState>No matching variables</LogEmptyState>}
    </div>
  );
}
